"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JwtRoutes = void 0;
const auth_route_1 = require("./auth_route");
class JwtRoutes extends auth_route_1.AuthRoute {
    constructor() {
        super('jwt');
    }
    /**
     * Request a new JWT for a user account.
     * Requires successful reception of OTP for account phone number.
     * If no account exists yet for the phone number, create one.
     * @param { string } otp
     * @param { string } identifier the phone number or email address for the OTP
     * @param { string } otpType should be either "USSD" or "SMS"
     */
    getJwt(otp, identifier, otpType) {
        return this.post(`?otp=${otp}`, { identifier, otpType });
    }
    /**
     * Check if the JWT is valid.
     * If valid, the route will return HTTP 200, and an error code otherwise.
     */
    validateJwt() {
        return this.get(`/validate`, {});
    }
    /**
     * Attempt to refresh the current JWT.
     * If successful, a new valid JWT will be returned.
     */
    refreshJwt() {
        return this.post(`/refresh`, {});
    }
}
exports.JwtRoutes = JwtRoutes;
//# sourceMappingURL=jwt.js.map